<ng-template #refresh>
    <app-component-loading size="inline"></app-component-loading>
</ng-template>

<ng-template #signersView  let-modal>
    <div class="modal-body">
        <app-signers (updateEvent)="updateEvent.emit()"
                     [editPermission]="right.is_edit_signer"
                     [fileUkey]="fileModel.key"
        ></app-signers>
        <app-visors (updateApproveEvent)="approveEmit.emit()"
                    (updateEvent)="updateEvent.emit()"
                    [editPermission]="right.is_edit_approver"
                    [fileKey]="fileModel.key"
                    [fileModel]="fileModel"
        ></app-visors>
    </div>
</ng-template>

<ng-template #editDocument  let-modal>
    <div class="modal-body" style="width: 500px;">
        <h3>{{ 'MODALS.FIELDS.TITLE' | translate }}</h3>
        <input #newFileName
               [value]="fileModel.name"
               class="form-control"
               type="text">

        <h3 style="margin-top: 14px;">{{ 'MODALS.FIELDS.DESCRIPTION' | translate }}</h3>
        <app-component-ckeditor
                (emitFinish)="description = $event[1]"
                [inputData]="fileModel.description"
                [isShowButtons]="false"
        ></app-component-ckeditor>

        <button (click)="editDocumentData(newFileName.value)" data-action="editDocumentData" 
					class="button-icon size-xl primary-button" style="margin-top: 14px;">
          <mat-icon svgIcon="save-2-fill"> </mat-icon>
          <span>{{  'MODALS.BUTTONS.SAVE' | translate }}</span>
        </button>
    </div>
</ng-template>

<ng-template #updateView  let-modal>
    <div class="modal-body">
        <h1 style="text-align: left">{{ 'MODALS.HEADERS.NEW_VERSION' | translate }}</h1>
        <div class="custom-file"
             style="text-align: left;">
            <input #file
                   class="form-control"
                   id="customFile"
                   type="file">
            <label class="form-label" style="margin-top: 8px; padding-left: 0.35rem"
                   data-browse="{{ 'MODALS.BUTTONS.SELECT' | translate }}"
                   for="customFile"
            >
                {{ file.files.length ? file.files[0].name : 'MODALS.FIELDS.SELECT.EMPTY' | translate }}
            </label>
        </div>
        <div  style="text-align: left;">
            <label style=" padding-left: 0.35rem" for="validationTextarea">{{ 'MODALS.FIELDS.DESCRIPTION' | translate }}</label>
            <textarea #description
                      class="form-control"
                      id="validationTextarea"
                      placeholder="{{ 'MODALS.TEXT.FILE_DESCRIPTION_PLACEHOLDER' | translate }}"></textarea>
        </div>
        <button (click)="onNewVersion(file, description)" data-action="uploadNewVersionButton"   [disabled]="isLockButton"
          class="button-icon size-xl primary-button" style="margin-top: 13px;">
          <mat-icon svgIcon="upload-2-line"> </mat-icon>
          <span *ngIf="!isLockButton else refresh">{{ 'MODALS.BUTTONS.UPLOAD' | translate }}</span>
        </button>
    </div>
</ng-template>

<ng-template #infoView let-modal>
    <div class="modal-body">
        <div style="text-align: left;">
            <h1>{{ 'MODALS.HEADERS.PROPERTIES' | translate }}</h1>
            <h3>{{ 'MODALS.TEXT.TITLE' | translate }}: {{ fileModel.name }}</h3>
            <h3>{{ 'MODALS.TEXT.DESCRIPTION' | translate }} : </h3>
            <div [innerHTML]="fileModel.description ? fileModel.description : ('EMPTY_FIELDS.EMPTY' | translate)" ></div>
            <h3>{{ 'MODALS.TEXT.TYPE.TYPE' | translate }}
                : {{ 'MODALS.TEXT.TYPE.' + fileModel.type_str | translate }}</h3>
            <h3>{{ 'MODALS.TEXT.CREATED_AT' | translate }}: {{ helper.formatDate(fileModel.created_at) }}</h3>
            <h3>{{ (fileModel.signed ? 'MODALS.TEXT.DOC_SIGNED' : 'MODALS.TEXT.DOC_WAIT') | translate }}</h3>
        </div>

        <h3>{{ 'MODALS.TEXT.INFO' | translate }}</h3>
        <app-detail-property
                (refreshEmit)="updateEvent.emit()"
                [canEdit]="right.is_edit_property"
                [customProperties]="fileModel.custom_properties"
                [targetKey]="fileModel.key"

                [target]="'file'"
        ></app-detail-property>
    </div>
</ng-template>

<div class="doc-title">
    <div class="doc-title-data">
        <div class="doc-title-data-filename">{{fileModel?.name}} </div>
        <div class="doc-title-data-version"> {{ 'DOCUMENTS.TEXT.VERSION' | translate }} {{ currentVersion?.created_at | date:'HH:mm dd.MM.yyyy' }}</div>
    </div>
     <div class="doc-title-version-history">
       <button (click)="toggleVersionHistory()" data-action="showRoadMapHistoryList"
       class="button-icon size-l primary-button" >
       <mat-icon [svgIcon]="'timer-2-line'"> </mat-icon>
       <span>{{'CONTRACTS.CARD.HISTORY'|translate}} </span>
      </button>
    </div>
</div>
<div class="doc-buttons" *ngIf="fileModel && currentVersion">
  <button                             
     *ngIf="currentMemberSigner && fileModel.latest_version &&  !['xlsx', 'xls'].includes(fileModel.latest_version.name.split('.').reverse()[0])"
     (click)="onCheckErrorSign(pinCodeView, 'pin')" data-action="signDocument"
    [disabled]="isImSign ? !(lockSignButton && !isImSign) : lockSignButton"
    [matTooltip]="!isImSign && lockSignButton ? ('DOCUMENTS.TEXT.READ' | translate) : ''"
    class="button-icon size-l primary-button">
    <mat-icon svgIcon="file-edit-fill"> </mat-icon>
    <span>{{ (!isImSign ? 'DOCUMENTS.BUTTONS.SIGN' : 'DOCUMENTS.BUTTONS.SIGNED') | translate }}</span>
  </button>
  <button (click)="openDialog(updateView)" data-action="uploadNewVersion" [disabled]="fileModel.is_approved || fileModel.signed"
    class="button-icon size-l secondary-button">
    <mat-icon svgIcon="file-copy-2-fill"> </mat-icon>
    {{ 'DOCUMENTS.BUTTONS.NEW_VERSION' | translate }}
  </button>

  <button  [matMenuTriggerFor]="downloadMenu" data-action="downloadPDF" class="button-icon size-l secondary-button">
    <mat-icon svgIcon="download-2-line"> </mat-icon>
    {{'DOCUMENTS.BUTTONS.DOWNLOAD'|translate}}
  </button>
  <mat-menu #downloadMenu="matMenu" panelClass="panel-menu-base" class="panel-menu-base">
    <button 
        *ngIf="currentMember.project_setting.is_project_admin"
        (click)="downloadFile(true)"
        disableRipple class="panel-menu-child-item" mat-menu-item
    >
        {{'DOCUMENTS.BUTTONS.ORIGINAL' | translate}}
    </button>
    <button (click)="downloadFile(false, 'pdf')" disableRipple class="panel-menu-child-item" mat-menu-item>PDF</button>
    <button 
        *ngIf="!isPdfView() && fileModel.latest_version &&['docx', 'doc'].includes(fileModel.latest_version.name.split('.').reverse()[0])"
        (click)="downloadFile(false, 'docx')" disableRipple class="panel-menu-child-item" mat-menu-item 
    >
        DOCX
    </button>
    <button 
        *ngIf="!isPdfView()&&fileModel.latest_version && ['xlsx', 'xls'].includes(fileModel.latest_version.name.split('.').reverse()[0])"
        (click)="downloadFile(false, 'xlsx')" disableRipple class="panel-menu-child-item" mat-menu-item
    >
        XLSX
    </button>
	</mat-menu>
  <button (click)="openDialog(signersView,600)" data-action="openSigners" class="button-icon size-l secondary-button">
    <mat-icon svgIcon="user-settings-fill"> </mat-icon>
    {{'DOCUMENTS.BUTTONS.SIGNERS'|translate}}
  </button>
  <button (click)="openDialog(infoView)" data-action="openInfo"class="button-icon icononly size-l secondary-button"
    matTooltip="{{ 'DOCUMENTS.BUTTONS.DOC_INFO' | translate }}" >
    <mat-icon svgIcon="information-fill"> </mat-icon>
  </button>
  <button (click)="openDialog(editDocument)" data-action="openDocumentEditor" class="button-icon icononly size-l secondary-button"
   matTooltip="{{ 'DOCUMENTS.BUTTONS.EDIT_DOC'  | translate }}" >
    <mat-icon svgIcon="settings-3-fill"> </mat-icon>
  </button>
  <button (click)="deleteFile()" data-action="deleteFile" class="button-icon icononly size-l secondary-button"
    matTooltip="{{ 'DOCUMENTS.BUTTONS.DELETE_FILE'  | translate }}" >
    <mat-icon svgIcon="delete-bin-fill"> </mat-icon>
  </button>
</div>
<div *ngIf="currentVersion && currentVersion.description"
     [innerHtml]="currentVersion.description"
     class="text-secondary p-1 border rounded"
     style="background: #ffffff; text-align: left"
></div>

<nav *ngIf="!fileModel"
     class="navbar navbar-expand-lg navbar-light bg-light">
    <div class="navbar-text">
        <app-component-loading></app-component-loading>
    </div>
</nav>